import { AppShell } from '@components/AppShell';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_shell')({
  component: () => (
    <AppShell>
      <Outlet />
    </AppShell>
  ),
});
